// extracted by mini-css-extract-plugin
export default {"wrapper":"MarketFacts_wrapper__N9JxU","wrapper__item":"MarketFacts_wrapper__item__mN--f"};